(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-products"] && !Shopify.designMode) return;
  try {
    
(function () {
  var tabs = document.querySelectorAll('[data-coll-tab]');
  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      var targetId = 'coll-panel-' + tab.dataset.collTab;

      // Deactivate all tabs + panels in the same section
      var section = tab.closest('.shopify-section') || document;
      section.querySelectorAll('[data-coll-tab]').forEach(function (t) {
        t.classList.remove('is-active');
        t.setAttribute('aria-selected', 'false');
      });
      section.querySelectorAll('.coll-panel').forEach(function (p) {
        p.classList.remove('is-active');
      });

      // Activate clicked tab + matching panel
      tab.classList.add('is-active');
      tab.setAttribute('aria-selected', 'true');
      var panel = section.querySelector('#' + targetId);
      if (panel) panel.classList.add('is-active');
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
